export default {
  wblcategory: {
    columnlist: "열 목록",
    create: "당신의 백인 검은 색 목록 카테고리 만들기",
    name: "이름",
    targettable: "목표 테이블",
    title: "화이트 / 블랙리스트 카테고리",
    update: "화이트 블랙리스트 카테고리 업데이트",
    choose_columnlist: "열리스트 선택"
  },
}